<template>
    <div class="act-benefit-page">
        <div class="act-content">
            <div class="oclock" v-if="timeLeft >= 0">{{ timeDisplay }}</div>
            <div class="scroller">
                <div class="whole-bg">
                    <div class="ic_title"></div>
                    <div class="title_tip">下载登录，下方三款游戏中选择其一，获得免费游玩</div>
                    <div class="g-list">
                        <div v-for="item in gameList" :key="item.id" class="g-item">
                            <div class="g-img-bg">
                                <img :src="$Utils.filterImgUrl(item.game_img)" />
                            </div>
                            <div class="g-name">{{ item.game_name }}</div>
                            <div class="btn-select" @click="checkThisGame(item)"></div>
                            <div class="free-time">{{ item.sign_tip }}</div>
                        </div>
                    </div>
                    <div class="rules-title"></div>
                    <div class="rules-section">
                        <div class="rules-row" v-for="(item, index) in ruleTxtList" :key="index">
                            <div class="num">{{ index + 1 }}</div>
                            <span class="txt">{{ item }}</span>
                        </div>
                    </div>
                    <div class="last-ex">*本次活动的最终解释权归属乐速盒子</div>
                </div>
            </div>
        </div>
        <div class="inner-mask" v-if="showPop"></div>
        <div class="inner-dialog" v-if="showPop">
            <div class="pop-x" @click="innerPopClose"></div>
            <!-- 领取成功、提示下载 -->
            <div v-if="gotFreeGameItem" class="inner-content">
                <div class="title">{{ gotFreeGameItem.game_name }}</div>
                <div class="g-item">
                    <img :src="$Utils.filterImgUrl(gotFreeGameItem.game_img)" />
                </div>
                <div class="tip">请下载客户端后前往 “福利中心” 领取畅玩福利</div>
                <div class="go-down" @click="goDownClick"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDownBenefitList } from '@/http/api/activity'

export default {
    name: 'ActBenefit',
    data() {
        return {
            isShow: false,
            gameList: [],
            ruleTxtList: ['用户可从三款游戏中任选一款，获得此款游戏的免费畅玩时长', '畅玩时长不可暂停，自用户获得奖励后开始计时', '已选择的游戏不可更改', '每名用户只能参与本活动一次'],
            showPop: false,
            gotFreeGameItem: null, // 已经领取的游戏
            totalSeconds: 3600, // 总计1小时 3600
            timeLeft: 3600, // 剩余时间，每天倒计时一次， 当天缓存剩余时间，第二天重新倒计时
            timer: null
        }
    },
    computed: {
        timeDisplay() {
            const h = Math.floor(this.timeLeft / 3600)
            const m = Math.floor((this.timeLeft % 3600) / 60)
            const s = this.timeLeft % 60
            return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    mounted() {
        this.getGameList()
        this.startCountdown()
    },
    methods: {
        // 选择游戏按钮
        checkThisGame(item) {
            this.gotFreeGameItem = item
            this.showPop = true
        },
        // 点击下载
        goDownClick() {
            // 其他下载上报 15
            this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 15 })
            // 通知到App.vue里面去下载
            this.$EventBus.$emit('app-dl')
        },
        // 游戏列表
        getGameList() {
            getDownBenefitList({ page: 1, size: 3, is_enable: 1 }).then((res) => {
                if (res.code === 200) {
                    const tmpList = res.data.list || []
                    for (let i = 0; i < tmpList.length; i++) {
                        const freeTime = tmpList[i].free_time
                        let sign_tip = ''
                        if (freeTime >= 100 * 365 * 24) {
                            sign_tip = '永久游玩'
                        } else if (freeTime % 24 === 0) {
                            sign_tip = `限玩${parseInt(freeTime / 24)}天`
                        } else {
                            sign_tip = `限玩${freeTime}小时`
                        }
                        tmpList[i].sign_tip = sign_tip
                    }
                    this.gameList = tmpList
                }
            })
        },
        // 内部弹窗关闭
        innerPopClose() {
            this.showPop = false
        },
        pad(num) {
            return num < 10 ? '0' + num : num
        },
        getTodayKey() {
            const now = new Date()
            return `countdown_${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
        },
        startCountdown() {
            const key = this.getTodayKey()
            let startTime = localStorage.getItem(key)

            if (!startTime) {
                startTime = Date.now()
                localStorage.setItem(key, startTime)
            }

            const elapsed = Math.floor((Date.now() - startTime) / 1000)
            console.log('已经计时 ' + elapsed)
            this.timeLeft = Math.max(this.totalSeconds - elapsed, -1)
            console.log('剩余时间 ' + this.timeLeft)
            // 避免多个计时器
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--
                } else {
                    clearInterval(this.timer)
                    this.timeLeft = -1
                }
            }, 1000)
        }
    }
}
</script>

<style lang="less" scoped>
.act-benefit-page {
    .inner-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
        z-index: 104;
    }

    .inner-dialog {
        position: fixed;
        z-index: 105;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 420px;
        height: 340px;
        border-radius: 30px;
        border: 2px solid #000;
        background: #622a20;

        .pop-x {
            position: absolute;
            top: 25px;
            right: 25px;
            width: 20px;
            height: 20px;
            background: url(../../../assets/act/pop_x.png) center/100% no-repeat;
            cursor: pointer;
        }

        .inner-content {
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #ffbd13;

            .title {
                font-size: 20px;
                font-weight: 600;
            }

            .g-item {
                margin-top: 15px;
                width: 260px;
                height: 140px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .tip {
                margin-top: 15px;
            }

            .go-down {
                margin-top: 15px;
                width: 144px;
                height: 45px;
                background: url(../../../assets/act/pop_down.png) center/100% no-repeat;
                cursor: pointer;
            }

            .g-sec-title {
                margin-top: 5px;
            }
            .g-got-item {
                margin-top: 30px;
            }
            .g-free-time {
                margin-top: 15px;
                font-size: 16px;
                color: #af8079;
            }

            .tip-title {
                margin-top: 50px;
                font-size: 20px;
                font-weight: 600;
            }

            .tip-desc {
                text-align: center;
                margin-top: 15px;
                font-size: 16px;
                color: #deb2ac;
                min-height: 80px;
            }
            .btn-ok {
                margin-top: 15px;
                width: 144px;
                height: 45px;
                background: url(../../../assets/act/pop_ok.png) center/100% no-repeat;
                cursor: pointer;
            }
            .btn-refresh {
                margin-top: 15px;
                width: 144px;
                height: 45px;
                background: url(../../../assets/act/pop_refresh.png) center/100% no-repeat;
                cursor: pointer;
            }
        }
    }

    .act-content {
        position: relative;
        top: 0;
        left: 50%;
        width: 1350px;
        transform: translateX(-50%);
        height: 100vh;
        z-index: 101;
        border-radius: 10px;
        letter-spacing: 1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;

        .oclock {
            position: fixed;
            z-index: 102;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            width: 97px;
            height: 100px;
            background-image: url(../../../assets/act/act_oclock.png);
            background-size: 97px 80px;
            background-position: top center;
            background-repeat: no-repeat;

            padding-top: 75px;
            text-align: center;
            color: #eec633;
            font-size: 14px;
            text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        }
    }

    .scroller {
        overflow-y: auto;
        width: 1350px;

        .whole-bg {
            margin: 0 auto;
            width: 1350px;
            background: url(../../../assets/act/act_bg.png) top center no-repeat #000;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .ic_title {
            flex-shrink: 0;
            margin-top: 290px;
            width: 792px;
            height: 483px;
            background: url(../../../assets/act/act_title.png) center/100% no-repeat;
        }
        .title_tip {
            margin-top: -100px;
            font-size: 24px;
            font-weight: bold;
            color: #ffcf4e;
        }

        .g-list {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            .g-item {
                margin: 0 24px;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;

                .free-time {
                    position: absolute;
                    top: -12px;
                    right: -5px;
                    padding: 0 8px;
                    height: 24px;
                    line-height: 24px;
                    background: #ffbb0b;
                    color: #04020a;
                    font-size: 16px;
                    font-weight: bold;
                }

                .g-img-bg {
                    width: 287px;
                    height: 183px;
                    background: url(../../../assets/act/game_bg.png) center/100% no-repeat;

                    img {
                        margin: 3px 0 0 4px;
                        width: 275px;
                        height: 171px;
                        object-fit: cover;
                        overflow: hidden;
                        clip-path: polygon(14px 0%, 100% 0%, 100% 100%, 0% 100%, 0% 18px);
                    }
                }
                .g-name {
                    margin: 10px 0 15px 0;
                    font-size: 20px;
                    font-weight: bold;
                    color: #fff;
                }
                .btn-select {
                    width: 164px;
                    height: 51px;
                    background: url(../../../assets/act/ic_btn_select.png) center/100% no-repeat;
                    &:hover {
                        cursor: pointer;
                        background: url(../../../assets/act/ic_btn_select_hover.png) center/100% no-repeat;
                    }
                }
            }
        }

        .rules-title {
            margin-top: 120px;
            width: 569px;
            height: 127px;
            background: url(../../../assets/act/ic_title_rules.png) center/100% no-repeat;
        }

        .rules-section {
            margin-top: 50px;

            .rules-row {
                margin-bottom: 6px;
                .num {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: bold;
                    background: #f9b742;
                }
                .txt {
                    padding-left: 13px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.6);
                }
            }
        }

        .last-ex {
            padding: 35px 0 60px 0;
            width: 500px;
            font-size: 18px;
            color: rgba(255, 255, 255, 0.5);
        }
    }
}
</style>
